'use client'
import { PrismicRichText } from "@prismicio/react";
import { isFilled } from "@prismicio/client";
import { Splide, SplideSlide } from "@splidejs/react-splide";
import '@splidejs/react-splide/css/core';

const Quote = ({ item, idx }) => (

  <div
    key={idx}
    className="flex flex-col h-full gap-6 text-dark-green"
  >
    {isFilled.richText(item.quote) && (
      <div className="flex gap-2">
        <div className="mt-1.5 md:mt-2.5">
          <svg width="14" height="11" viewBox="0 0 14 11" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M5.194 0.323999L5.916 1.616C5.51067 2.17333 5.13067 2.794 4.776 3.478C4.44667 4.162 4.25667 4.87133 4.206 5.606L6.296 5.986V10.356H0.482V7.24C0.482 5.44133 0.9 3.99733 1.736 2.908C2.59733 1.79333 3.75 0.931999 5.194 0.323999ZM12.718 0.323999L13.44 1.616C13.0347 2.17333 12.6547 2.794 12.3 3.478C11.9707 4.162 11.7807 4.87133 11.73 5.606L13.82 5.986V10.356H8.006V7.24C8.006 5.44133 8.424 3.99733 9.26 2.908C10.1213 1.79333 11.274 0.931999 12.718 0.323999Z" fill="#003A33" />
          </svg>
        </div>
        <div className="flex flex-col gap-4">
          <PrismicRichText field={item.quote}
            components={{
              paragraph: ({ children }) => <p className="text-quote after-quote pr-4">{children}</p>,

            }} />

          {isFilled.keyText(item.author_name) && (
            <div className="flex flex-col gap-1">
              <span className="text-author-name">
                {item.author_name}
              </span>
              {isFilled.keyText(item.author_title) && (
                <span className="p text-[#A7A6A1]">
                  {item.author_title}
                </span>

              )}
            </div>
          )}
        </div>
      </div>
    )}
  </div>
);

/**
 * @typedef {import("@prismicio/client").Content.TestimonialSlice} TestimonialSlice
 * @typedef {import("@prismicio/react").SliceComponentProps<TestimonialSlice>} TestimonialProps
 * @type {import("react").FC<TestimonialProps>}
 */
const Testimonial = ({ slice }) => {
  const { testimonials, title } = slice.primary;
  return (
    <section
      data-slice-type={slice.slice_type}
      data-slice-variation={slice.variation}
      className="framing py-20 md:py-24 bg-white bg-[url('/bg-patterns-yyp.svg')] bg-no-repeat bg-center bg-cover text-dark-green"
    >
      <div className="max-w-300 mx-auto flex flex-col gap-8 md:gap-16">
        {isFilled.richText(title) && (
          <div className="max-w-200">
            <PrismicRichText
              field={title}
              components={{
                heading2: ({ children }) => (
                  <h2 className="h3">{children}</h2>
                ),
                heading3: ({ children }) => (
                  <h3 className="h3">{children}</h3>
                ),
              }}
            />
          </div>
        )}
        <div className="slide-inline">
          {(isFilled.group(testimonials) && testimonials.length > 1) ? (
            <Splide
              options={{
                type: "loop",
                perPage: 1,
                perMove: 1,
                gap: "5rem",
                arrows: true,
                pagination: false,
                speed: 1500,
                breakpoints: {
                  767: {
                    perPage: 1,
                    arrows: false,
                    pagination: true,
                  },
                },
              }}
            >
              {testimonials.map((testimonial, idx) => (
                <SplideSlide key={idx}>
                  <Quote item={testimonial} idx={idx} />
                </SplideSlide>
              ))}
            </Splide>
          ) : <div className="">
            <div className="flex gap-10">
              {
                testimonials.map((testimonial, idx) => (
                  <Quote key={idx} item={testimonial} idx={idx} />
                ))
              }
            </div>
          </div>
          }
        </div>
      </div>

    </section>
  );
};

export default Testimonial;
